import React from 'react'
import PropTypes from 'prop-types'

export default function ReelImage({ styles, tag, ...rest }) {
  const Tag = tag || 'img'
  return <Tag className={`${styles.reelImage}`} width="100%" height="100%" {...rest} />
}

ReelImage.propTypes = {
  styles: PropTypes.object.isRequired,
  tag: PropTypes.string
}
